
import "./App.css";
//import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import HomeView from "./screens/HomeView";
//import FormLogin from "./screens/FormLogin";
//import FormRegister from "./screens/FormRegister";

function App() {

  return (
    <div className="App">                        
     <HomeView /> 
    </div>
  );
}

export default App;
/*
<BrowserRouter>
        <Routes>
          <Route exact strict path="/"  element={<HomeView />} />
          <Route exact strict path="/login" element={<FormLogin />} />
          <Route exact strict path="/register" element={<FormRegister />} />
        </Routes>
        <Link to="/">Home</Link>
      <Link to="/login">Login</Link>
      <Link to="/register">FormRegister</Link>
      </BrowserRouter>
*/